import { OptionDescription } from './option.type';
import { EYesNo, EYesNoBlank } from '../enums/yes-no.enum';

export type YesNoOption = OptionDescription<EYesNo> & { viewClass: string };
export type YesNoRecord = Record<EYesNo, YesNoOption>;

export type YesNoBlankOption = OptionDescription<EYesNoBlank> & { viewClass: string };
export type YesNoBlankRecord = Record<EYesNoBlank, YesNoBlankOption>;